<template>
  <div class="row">
    <div class="col-md-12 text-right custom_style_for_mob ">
      <div class="pull-left d-inline">
        <h1 class="new-design-heading-label d-inline">{{ pluralize(property.property_name) }}</h1>
      </div>
      <span class="d-inline clickable" data-toggle="modal"
           :data-target="`#property_popup_${property.property_id}`">
         <span  class="float-right">
       <a href="javascript:;">
              <svg width="20" style="fill: #2E4051;" height="20" viewBox="0 0 20 20" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10
                  18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                        fill="#03A9F4"/>
              </svg>
          </a>
      </span>
      <span  class="select-services-dropdown-add-label float-right">Add</span>

      </span>
      <customer-property-creation-popup :customer-id="customerId" :country-code="countryCode" :country-key="countryKey"
                                        :date-format="dateFormat" :property="property"
                                        :id="`property_popup_${property.property_id}`"></customer-property-creation-popup>
    </div>
    <div class="col-md-12 col-xs-12 col-sm-12">
      <customer-properties-dropdown :property="property" :customer-id="customerId"></customer-properties-dropdown>
    </div>
    <div class="col-md-12 min-height-100px mt-3">
      <div v-for="(selected, index) of selectedProperties" :key="index">
        <input type="hidden" name="customer_property_id[]" :value="selected.customer_property_id">
        <customer-property-item :customer-id="customerId"
                                :property="selected"
                                :country-code="countryCode"
                                :date-format="dateFormat"
                                :property-name="property.property_name"
                                :country-key="countryKey"></customer-property-item>
      </div>
    </div>
  </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";
import pluralize from "pluralize";

export default {
  name: "CustomerProperty",
  props: {
    property: {
      required: true
    },
    dateFormat: {
      required: true
    },
    countryCode: {
      required: true
    },
      countryKey: {
          required: true
      },
    customerId: {
      required: true
    },
      bookingId:0
  },
  data() {
    return {
      selectedProperties: []
    }
  },
  methods: {
    initializeEventListeners() {
      EventBus.$on('onCustomerPropertySelected', (data) => {

          let dataModified = ! data[0] ? [data] : data;
        console.log(data);
          for (let index in dataModified){

              console.log(dataModified[index].value)


              let propertyExists = this.selectedProperties
                  .filter(property => property.customer_property_id == dataModified[index].customer_property_id).length > 0;

              if (this.property.property_id == dataModified[index].property_id && !propertyExists) {
                if (dataModified[index].address  && (!this.bookingId || parseInt(this.bookingId) === 0)){
                  window.UpdateAddressfromText(dataModified[index].address);
                  }

                  this.selectedProperties.push(dataModified[index])
              }
          }

      })
      EventBus.$on('onCustomerPropertyCreated', (data) => {
        if (this.property.property_id == data.property_id) {
          if (data.customer_primary_field_address_value && (!this.bookingId || parseInt(this.bookingId) === 0) ){
                window.UpdateAddressfromText(data.customer_primary_field_address_value);
            }
          this.selectedProperties.push({
            value: data.customer_primary_field_vlaue,
            customer_property_id: data.customer_property_id,
            customer_id: this.customerId,
            property_id: data.property_id
          })
        }
      })
      EventBus.$on('onCustomerPropertyDeleted', property => {
        if (this.property.property_id == property.property_id) {
          this.selectedProperties.splice(this.selectedProperties.indexOf(property), 1)
        }
      })
    },
    pluralize(string) {
      return pluralize(string)
    }
  },
  mounted() {
    this.initializeEventListeners();
  },
  computed: {
    customerChanged() {
        return this.customerId

    }
  },
  watch: {
    customerChanged: function () {
      this.selectedProperties = []
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 480px) {
    .custom_style_for_mob{
        padding-bottom: 9px;
    }
}
</style>